var _rect, _rect2, _g, _rect3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 46.7,
    height: 46.7,
    rx: 4.35,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 46.7,
    height: 46.7,
    rx: 4.35,
    stroke: "#DBDEE1",
    strokeWidth: 1.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter0_f_4462_27439)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.5918,
    y: 24,
    width: 28.0945,
    height: 17.5591,
    rx: 8.77954,
    fill: "url(#paint0_linear_4462_27439)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.74023,
    y: 8.74219,
    width: 30.4357,
    height: 30.4357,
    rx: 12.3724,
    fill: "url(#paint1_linear_4462_27439)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4462_27439)",
    filter: "url(#filter1_i_4462_27439)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_4462_27439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0553 25.1363L28.5638 21.8538H25.4311V19.7201C25.4311 18.8226 25.8685 17.9455 27.267 17.9455H28.7113V15.1502C27.8702 15.014 27.0203 14.9403 26.1685 14.9297C23.5902 14.9297 21.9069 16.5043 21.9069 19.3508V21.8538H19.0488V25.1363H21.9069V33.0759H25.4311V25.1363H28.0553Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4462_27439",
    x: 4.1318,
    y: 18.54,
    width: 39.0138,
    height: 28.4786,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.73,
    result: "effect1_foregroundBlur_4462_27439"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4462_27439",
    x: 14.5137,
    y: 14.5156,
    width: 18.5586,
    height: 18.7648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.206207
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.515516
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4462_27439"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_4462_27439",
    x: 19.0488,
    y: 14.9297,
    width: 9.66211,
    height: 18.3507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.206207
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.412413
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4462_27439"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4462_27439",
    x1: 23.6391,
    y1: 41.046,
    x2: 23.6391,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4462_27439",
    x1: 23.9581,
    y1: 38.2886,
    x2: 23.9581,
    y2: 8.74219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4462_27439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.5586,
    height: 18.5586,
    fill: "white",
    transform: "translate(14.5137 14.5156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookImg);
export default __webpack_public_path__ + "static/media/facebook-img.02cc24c7e8e10f973e27fa9a1e201087.svg";
export { ForwardRef as ReactComponent };